import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LayersIcon from "@mui/icons-material/Layers";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";

import FilterDisplayButton from "components/Filters/FilterDisplayButton";

export type PpDisplayType = "Table" | "Grid" | "List";

interface PpControlsProps {
  showFilters: boolean;
  onShowFilter: () => void;
  onDisplayChange: (_type: PpDisplayType) => void;
}

const PpControls = ({
  showFilters,
  onShowFilter,
  onDisplayChange,
}: PpControlsProps) => {
  return (
    <Box display="flex">
      <Box
        sx={{
          flex: "0 1 283px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FilterDisplayButton onClick={onShowFilter} show={showFilters} />
      </Box>

      <Box flex={5} sx={{ display: "flex", marginLeft: "1em" }}>
        <ToggleButtonGroup
          exclusive
          defaultValue={1}
          sx={{
            flex: 5,
            justifyContent: "center",
          }}
        >
          <ToggleButton
            value={1}
            id="table-btn"
            onClick={() => onDisplayChange("Table")}
          >
            <FormatListBulletedIcon />
            <span className="visually-hidden">Table View</span>
          </ToggleButton>

          <ToggleButton
            value={2}
            id="list-btn"
            onClick={() => onDisplayChange("List")}
          >
            <LayersIcon />
            <span className="visually-hidden">List View</span>
          </ToggleButton>

          <ToggleButton
            value={3}
            id="grid-btn"
            onClick={() => onDisplayChange("Grid")}
          >
            <WindowOutlinedIcon />
            <span className="visually-hidden">Grid View</span>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default PpControls;
